import React, { useState, FC } from "react";
import getModalStyle from "../../../../util/getModalStyle";

function usePoSelector() {
  const [modalStyle] = useState(() => getModalStyle(50, 50));
  return { modalStyle };
}

export default usePoSelector;
